export default Object.freeze({
  DEVELOPER: 'DEVELOPER',
  ADMIN: 'ADMIN',
  HEAD: 'HEAD',
});
